import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionService, LogConsole, LogEntry, LogLevel, LogPublisher, LogApi } from '@nstep-common/core';

import { Enviroment } from "@nstep-common/core";

type PublisherName = 'console' | 'api';

@Injectable({
	providedIn: 'root'
})
export class LogService {

	level: LogLevel = LogLevel.All;
	logWithDate: boolean = true;

	private publishers: Record<PublisherName, LogPublisher>;
	private currentPublisher: LogPublisher | undefined;

	constructor(private httpClient: HttpClient,
		private sessionService: SessionService,
		private environment: Enviroment) {

		this.publishers = {
			console: new LogConsole(),
			api: new LogApi(this.httpClient, this.sessionService, this.environment)
		};
	}

	publisher(name: PublisherName): LogService {
		this.currentPublisher = this.publishers[name];
		return this;
	}

	debug(message: string, ...params: any[]): void {
		this.writeToLog(message, LogLevel.Debug, ...params);
	}

	info(message: string, ...params: any[]): void {
		this.writeToLog(message, LogLevel.Info, ...params);
	}

	warn(message: string, ...params: any[]): void {
		this.writeToLog(message, LogLevel.Warn, ...params);
	}

	error(message: string, ...params: any[]): void {
		this.writeToLog(message, LogLevel.Error, ...params);
	}

	fatal(message: string, ...params: any[]): void {
		this.writeToLog(message, LogLevel.Fatal, ...params);
	}

	log(message: string, ...params: any[]): void {
		this.writeToLog(message, LogLevel.All, ...params);
	}

	private writeToLog(message: string, level: LogLevel, ...params: any[]): void {
		const selectedPublisher = this.currentPublisher;
		this.currentPublisher = undefined;

		if (!message?.trim() || !this.shouldLog(level)) {
			return;
		}

		const entry: LogEntry = new LogEntry({
			message: message,
			level: level,
			extraInfo: params,
			logWithDate: this.logWithDate,
			source: this.environment.appName
		});

		const loggers = selectedPublisher
			? [selectedPublisher]
			: Object.values(this.publishers);

		for (const logger of loggers) {
			logger.log(entry).subscribe();
		}
	}

	private shouldLog(level: LogLevel): boolean {
		return this.level === LogLevel.All ||
			(level >= this.level && level !== LogLevel.Off);
	}
}
